export type OptInFormField = { name: string; datatype?: string; options?: string | null; [key: string]: unknown };
export type OptIn = { id: number; type: string; title: string };

export type FormOptInType = 'single' | 'double';

export const isOptInField = (field: OptInFormField) => field.datatype === 'optIn';

export const resolveOptIn = (field: OptInFormField, optIns: OptIn[]) => {
	const id = parseInt(field.options ?? '', 10);
	return optIns.find(optIn => optIn.id === id) ?? null;
};

// Fields are named "<type>OptIn.<random>" (see AddField), the only record of the type once the
// opt-in no longer resolves.
export const optInTypeOf = (field: OptInFormField, optIns: OptIn[]): FormOptInType => {
	const type = resolveOptIn(field, optIns)?.type ?? (field.name.startsWith('double') ? 'double' : 'single');
	return type === 'double' ? 'double' : 'single';
};

// An opt-in belongs to one brand, so `optIns` must be the form's brand's list. The template parser
// renders a field that doesn't resolve in it as an empty div: no consent checkbox (WEB-11304).
export const danglingOptInFields = <F extends OptInFormField>(fields: F[] = [], optIns: OptIn[]) => {
	const optInFields = fields.filter(isOptInField);
	if (!optInFields.length) {
		return [];
	}
	const offered = optIns.filter(optIn => optIn.type !== 'manual');
	return optInFields.filter(field => !resolveOptIn(field, offered));
};

export type OptInReplacements = Record<string, OptIn | null>;

export const withReplacedOptIns = <F extends OptInFormField>(fields: F[], replacements: OptInReplacements) =>
	fields.flatMap(field => {
		if (!(field.name in replacements)) {
			return [field];
		}
		const optIn = replacements[field.name];
		return optIn ? [{ ...field, options: String(optIn.id), title: optIn.title }] : [];
	});
